import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./headerStyle.css";
import { useTranslation } from "react-i18next";
import {
  IconButton,
  Drawer,
  Divider,
  List,
  ListItem,
  ThemeProvider,
  createTheme,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const SmallScreenBurgerMenu = () => {
  enum DEVIPage {
    Home,
    EVDA,
    EVMC,
    More,
  }

  const theme = createTheme({
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            maxHeight: "100vh",
          },
        },
      },
    },
  });

  const { t } = useTranslation();
  const options = [
    { value: "/", label: t("home"), deviPage: DEVIPage.Home },
    { value: "EVDA", label: t("evda_title"), deviPage: DEVIPage.EVDA },
    { value: "EVMC", label: t("evmc_title"), deviPage: DEVIPage.EVMC },
    { value: "static/more", label: t("more"), deviPage: DEVIPage.More },
  ];

  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const location = useLocation();

  const currentPage = (): DEVIPage | null => {
    if (location.pathname === "/") {
      return DEVIPage.Home;
    }

    if (location.pathname.startsWith("/EVDA")) {
      return DEVIPage.EVDA;
    }

    if (location.pathname.startsWith("/EVMC")) {
      return DEVIPage.EVMC;
    }

    if (location.pathname === "/static/more") {
      return DEVIPage.More;
    }

    return null;
  };

  return (
    <div id="menu-container">
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={handleDrawerOpen}
        edge="start"
        sx={{ mr: 2, ...(open && { display: "none" }) }}
        id="burger-menu-button"
        aria-expanded={open}
        aria-controls="menu-drawer"
      >
        <MenuIcon />
      </IconButton>

      <ThemeProvider theme={theme}>
        <Drawer
          open={open}
          onClose={handleDrawerClose}
          anchor="right"
          id="menu-drawer"
        >
          <div id="menu-drawer-header">
            <IconButton onClick={handleDrawerClose}>
              <ChevronRightIcon />
            </IconButton>
          </div>
          <Divider />
          <List id="menu-drawer-list">
            {options.map((option, index) => (
              <ListItem
                key={index}
                component={NavLink}
                disablePadding
                end
                to={option.value}
                className={
                  "nav-link " +
                  (currentPage() === option.deviPage ? "active" : "")
                }
                aria-current={
                  currentPage() === option.deviPage ? "page" : false
                }
                onClick={handleDrawerClose}
              >
                <ListItemText>
                  <div className="nav-item">
                    <h2>{option.label}</h2>
                    <hr></hr>
                  </div>
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </ThemeProvider>
    </div>
  );
};

export default SmallScreenBurgerMenu;
